import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import NavTitle from '../../nav-title'
import imgUser from '../../../images/user.png'
import UseEmpsUserAsset from '../../../hooks/use-detail-search'
import Autocomplete from '../../custom/autocomplete'
import {
  getRightOrgDetailAPI,
  postRightOrgDetailAPI
} from '../../../services/right-org'
import Error_500 from '../../error/error-500'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../error/error-false'
import Swal from 'sweetalert2'
import { PAGE_ORG_RIGHT } from '../../../router/routes'
import { Link, useNavigate } from 'react-router-dom'
import { useDebounce } from '@react-hook/debounce'
import TextNavTitle from '../../TextNavTitle'
import { FaAnglesRight } from 'react-icons/fa6'
import ImageNoDataCustom from '../../custom/ImageNoDataCustom'
import CardCustom from '../../custom/card-custom'
import SwalCustom from '../../../alert/swal-custom'

function AssetOrgAdd() {
  const [dataOrg, setDataOrg] = useState([])
  const [isSave, setIsSave] = useState(false)
  const [detail, setDetail] = useState([])
  const [detailRight, setDetailRight] = useState([])
  const [serchSelect, setSerchSelect] = useState()
  const [opSearch, setOpSearch] = useDebounce('', 1000)
  const optionSearch = UseEmpsUserAsset(opSearch)
  const navigate = useNavigate()
  useEffect(() => {
    if (serchSelect?.value) {
      getRightOrgDetail()
    } else {
      setDetailRight([])
      setDetail([])
    }
  }, [serchSelect])

  useEffect(() => {
    setDataOrg(detailRight)
  }, [detailRight])

  const getRightOrgDetail = async () => {
    const body = {
      orgId: serchSelect?.orgId,
      username: serchSelect?.value
    }

    const res = await getRightOrgDetailAPI(body)
    if (!res) return
    if (res.status) {
      setDetail(res?.result)
      setDetailRight(res?.result?.right)
    } else {
      Error_false(res)
    }
  }

  const handleOrgChange = (id, toDoList) => {
    setDetailRight((prev) => {
      return prev.map((d) =>
        d.right_org_id === id
          ? {
              ...d,
              ...toDoList,
              right_detail: d.right_detail.map((t) => ({
                ...t,
                status_checked:
                  toDoList.right_checked && t.status_id === 1 ? 1 : 0
              }))
            }
          : d
      )
    })
    setDataOrg(detailRight)
  }

  const handleSubStatus = (index, i) => {
    const subData = [...detailRight]
    const resetData = subData[i].right_detail.map((d) => ({
      ...d,
      status_checked: 0
    }))
    resetData[index] = {
      ...subData[i].right_detail[index],
      status_checked: 1
    }
    subData[i].right_detail = [...resetData]
    setDataOrg(subData)
  }

  const onSubmit = async () => {
    try {
      const checkNum = dataOrg.filter((item) => item.right_checked)

      const body = {
        orgId: serchSelect?.orgId ?? '',
        username: serchSelect.value ?? '',
        statusList: checkNum.map((d, i) => {
          let v = d.right_detail.find((item) => item.status_checked)
          return {
            statusOrgId: d.right_org_id,
            statusId: v.status_id
          }
        })
      }

      if (checkNum.length === 0) {
        Swal.fire({
          icon: 'error',
          title: `Please fill the information completely.`,
          showConfirmButton: false,
          timer: 3000
        })
      } else {
        setIsSave(true)
        const resp = await postRightOrgDetailAPI(body)
        setIsSave(false)
        getRightOrgDetail()
        if (resp && resp.status) {
          SwalCustom({
            title: 'Success!',
            text: TXTSUCCESS,
            timer: 1500,
            showConfirmButton: false
          }).then(() => {
            navigate(PAGE_ORG_RIGHT)
          })
        } else {
          Error_false(resp)
        }
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      <NavTitle>
        <TextNavTitle>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none pointer-event`}
          >
            Organization Right <FaAnglesRight />
            <label className="small fw-medium ms-2">Add Right</label>
          </Link>
        </TextNavTitle>
      </NavTitle>
      <Row className="justify-content-end mb-3">
        <Col xl={4} className="text-end my-auto">
          <label>Seach Employee:</label>
        </Col>
        <Col xl={4}>
          <Autocomplete
            isClearable={true}
            options={optionSearch}
            value={serchSelect}
            onChange={(data) => {
              setSerchSelect(data)
            }}
            onInputChange={(data) => {
              setOpSearch(data)
            }}
            placeholder="Org/ Code/ Username"
          />
        </Col>
      </Row>
      <CardCustom>
        {detailRight.length > 0 ? (
          <>
            <div className="p-3">
              <Row>
                <Col xl={1}>
                  <div className="d-flex align-items-middle justify-content-start mt-2 m-4 mb-0 me-0">
                    <Image
                      src={detail?.img_url ?? imgUser}
                      style={{ width: '70px', borderRadius: '50%' }}
                    />
                  </div>
                </Col>
                <Col xl={4}>
                  <div className="mt-3 m-5 mb-0 me-0">
                    <div className="d-flex justify-content-start small">
                      <p>
                        Name: {detail?.title_en ?? '-'}
                        {detail?.name_en ?? '-'} {detail?.surname_en ?? '-'} (
                        {detail?.nickname_en ?? ''})
                      </p>
                    </div>
                    <div className="small">
                      <p>Code: {detail?.code ?? '-'}</p>
                    </div>
                  </div>
                </Col>
                <Col xl={3}>
                  <div className="mt-3 ">
                    <div className="d-flex align-items-middle justify-content-start small">
                      <p>Department: {detail?.division_en ?? '-'}</p>
                    </div>
                    <div className="small">
                      <p>Position: {detail?.position_en ?? '-'}</p>
                    </div>
                  </div>
                </Col>
                <Col xl={3}>
                  <div className="mt-3">
                    <div className="d-flex justify-content-start small">
                      <p>Type: {detail?.type ?? '-'}</p>
                    </div>
                    <div className="small">
                      <p>Email: {detail?.email ?? '-'}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="p-3">
              <Table bordered className="mb-3">
                <thead
                  className=" text-white bg-hrms"
                  style={{ position: 'sticky', top: '0px', zIndex: 999 }}
                >
                  <tr className=" font-title-table">
                    <th
                      className="fw-normal "
                      style={{
                        whiteSpace: 'nowrap',
                        width: '50px'
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        whiteSpace: 'nowrap'
                      }}
                      className="fw-normal"
                    >
                      Organization Right
                    </th>
                    <th
                      className="fw-normal text-center"
                      style={{ whiteSpace: 'nowrap', width: '100px' }}
                    >
                      Enable
                    </th>
                    <th
                      className="fw-normal text-center"
                      style={{ whiteSpace: 'nowrap', width: '100px' }}
                    >
                      Read Only
                    </th>
                  </tr>
                </thead>
                <tbody className="text-break fw-light">
                  {detailRight.map((d, i) => (
                    <tr className="mb-3 align-middle" key={i}>
                      <td className="small">{i + 1}</td>
                      <td>
                        <Form.Check
                          type="checkbox"
                          label={d?.right_org}
                          checked={d?.right_checked}
                          onClick={() =>
                            handleOrgChange(d?.right_org_id, {
                              right_checked: !d?.right_checked // Toggle the checkbox status
                            })
                          }
                        />
                      </td>
                      {d?.right_detail.map((s, index) => (
                        <td key={`${i}-${index}`} className="text-center">
                          <Form.Check
                            // label={s?.status_name}
                            type="checkbox"
                            className="hidden-checkbox"
                            disabled={!d?.right_checked}
                            checked={s?.status_checked}
                            // checked={false}
                            onChange={() => {
                              handleSubStatus(index, i)
                            }}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Row>
                <div className="col-12">
                  <div className="d-flex justify-content-center gap-2 ">
                    <Button
                      disabled={isSave}
                      className="border-0"
                      style={{ minWidth: 200 }}
                      onClick={() => onSubmit()}
                    >
                      {isSave ? 'Saving...' : 'Save'}
                    </Button>
                  </div>
                </div>
              </Row>
            </div>
          </>
        ) : (
          <div className="p-3 text-center">
            <ImageNoDataCustom />
          </div>
        )}
      </CardCustom>{' '}
    </>
  )
}

export default AssetOrgAdd
